/**
 * @Description 发起审批弹框共通-备注输入、选择下个节点、后续节点审批人
 *
 *   目前使用的场景
 *     机会点提审批
 *     机会点区域保护
 *     门店合同签约审批
 */
import { FC, useRef } from 'react';
import { Form, Modal } from 'antd';
import { useMethods } from '@lhb/hook';
import V2Form from '@/common/components/Form/V2Form';
import V2FormTextArea from '@/common/components/Form/V2FormTextArea/V2FormTextArea';
import { createApproval } from '@/common/api/expandStore/approveworkbench';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { dealApprovalSumitExtras } from '@/common/components/business/ExpandStore/ApprovalSelectNodes/config';
import ApprovalSelectNodes from '@/common/components/business/ExpandStore/ApprovalSelectNodes';
import { ApprovalType, ApprovalTypeValue } from '../ts-config';
import styles from './index.module.less';

interface ApprovalCreateDialogProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  id:number; // 审批主体id
  type: ApprovalType;
  typeValue: ApprovalTypeValue;
  specialParams?: any; // 业务特有的提交审批参数（对象格式）
  onComplete?: () => void; // 提交成功
}

const ApprovalCreateDialog: FC<ApprovalCreateDialogProps> = ({
  visible,
  setVisible,
  id,
  type,
  typeValue,
  specialParams = {},
  onComplete,
}) => {
  const isLockRef = useRef<boolean>(false);
  const [form] = Form.useForm();

  const methods = useMethods({
    handleCancel() {
      setVisible(false);
      form.resetFields();
    },
    handleOk() {
      form.validateFields().then(async (values: any) => {
        methods.confirmDialog(values);
      });
    },
    /**
     * @description 确认提交弹框填写后提交事件
     * @param values 确认提交弹框的表单对象
     */
    async confirmDialog(values: any) {
      if (isLockRef.current) return;
      isLockRef.current = true;

      const extras: any = dealApprovalSumitExtras(values);
      const res = await createApproval({
        id,
        type,
        typeValue,
        ...specialParams,
        ...values,
        ...extras,
      }).finally(() => {
        isLockRef.current = false;
        setVisible(false);
      });
      if (res) {
        V2Message.success('提交审批成功');
        methods.handleCancel();
        onComplete?.();
      }
    },
  });

  return (
    <Modal
      title='发起审批'
      open={visible}
      destroyOnClose={true}
      width={336}
      onCancel={methods.handleCancel}
      onOk={methods.handleOk}
      className={styles.createModal}
    >
      <V2Form form={form}>
        <ApprovalSelectNodes
          id={id}
          type={type}
          typeValue={typeValue}
        />
        <V2FormTextArea
          label='申请理由'
          name='remark'
          maxLength={50}
          placeholder='请输入申请理由，最多输入50字'
          rules={[{ required: true, message: '请输入申请理由' }]}
        />
      </V2Form>
    </Modal>
  );
};
export default ApprovalCreateDialog;
